import { render, staticRenderFns } from "./assessmentCopy.vue?vue&type=template&id=8a876c20&scoped=true&"
import script from "./assessmentCopy.vue?vue&type=script&lang=js&"
export * from "./assessmentCopy.vue?vue&type=script&lang=js&"
import style0 from "./assessmentCopy.vue?vue&type=style&index=0&id=8a876c20&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a876c20",
  null
  
)

export default component.exports